import { Cascader, Form } from "antd";
import { useEffect, useState } from "react";
import get from "lodash/get";
import map from "lodash/map";
import last from "lodash/last";
import { useSelector } from "react-redux";
import NextIcon from "../static/icons/next.svg";

const SingleLocationInput = ({
  edit,
  actionss,
  onChange,
  inputHeading,
  noOnlyLocation,
  noInputHeading,
  setRules,
  placeHolderText,
  enableChangeOnSelect,
  hasClass,
  allowClear,
  displayOnlyChild,
  formValidator,
}) => {
  const [treeData, setTreeData] = useState([]);
  const companies = useSelector((state) =>
    get(state, "location.userZoneLocations.companyList", [])
  );
  const clients = useSelector((state) =>
    get(state, "location.userZoneLocations.clientList", [])
  );
  const zones = useSelector((state) =>
    get(state, "location.userZoneLocations.zoneList", [])
  );
  const locations = useSelector((state) =>
    get(state, "location.userZoneLocations.locationList", [])
  );

  const generateTree = (data, zoneNodeType) => {
    data = map(data, (node) => {
      if (
        data.length === 0 &&
        (zoneNodeType === "COMPANY" ||
          zoneNodeType === "CLIENT" ||
          zoneNodeType === "ZONE")
      ) {
        return [];
      }
      if (data.length === 0 && zoneNodeType === "LOCATION") {
        return null;
      }

      let children = [];
      if (get(node, "consumers", []).length) {
        children = generateTree(get(node, "consumers", []), "CLIENT");
      } else if (get(node, "zoneVOS", []).length) {
        children = generateTree(get(node, "zoneVOS", []), "ZONE");
      } else if (get(node, "subZones", []).length) {
        children = generateTree(get(node, "subZones", []), "ZONE");
      } else if (get(node, "locations", []).length) {
        children = generateTree(get(node, "locations", []), "LOCATION");
      }

      if (zoneNodeType === "LOCATION") {
        return {
          label: get(node, "name"),
          value: `${zoneNodeType}-${get(node, "id")}`,
          key: `${zoneNodeType}-${get(node, "id")}`,
        };
      }
      return {
        label: get(node, "name"),
        value: `${zoneNodeType}-${get(node, "id")}`,
        key: `${zoneNodeType}-${get(node, "id")}`,
        children,
      };
    });
    return data;
  };

  useEffect(() => {
    const compnayTree = generateTree(companies, "COMPANY");
    const clientTree = generateTree(clients, "CLIENT");
    const zoneTree = generateTree(zones, "ZONE");
    const locationTree = generateTree(locations, "LOCATION");
    setTreeData([...compnayTree, ...clientTree, ...zoneTree, ...locationTree]);
  }, []);

  const displayRender = (labels, selectedOptions) => {
 
    return map(labels, (label, i) => {
      const option = selectedOptions[i];
      if (i === labels.length - 1) {
        return <span key={get(option, "value", "")}>{label}</span>;
      }
      return !displayOnlyChild ? (
        <span key={get(option, "value", "")}>
          {label} <img src={NextIcon} alt="" />
        </span>
      ) : (
        <></>
      );
    });
  };

  const validateInput = (rule, value, callback) => {
    if (!value || enableChangeOnSelect) {
      callback();
      return;
    }
    const nodeArr = last(value).split("-");
    if (noOnlyLocation) {
      callback();
      return;
    }
    if (nodeArr[0] === "LOCATION") {
      callback();
      return;
    }
    callback(
      "This zone doesn't have a building please select another zone or create a builing"
    );
  };

  return (
    <>
      {treeData.length > 0 && (
        <Form.Item
          name="location_id"
          label={noInputHeading ? null : inputHeading || "Location"}
          rules={
            setRules
              ? []
              : [
                  {
                    required: true,
                    message: "Please Select Location",
                  },
                  {
                    validator: formValidator || validateInput,
                  },
                ]
          }
          className={hasClass ? "report-selector" : ""}
        >
          <Cascader
            className="cascader-space m0"
            options={treeData}
            allowClear={allowClear || false}
            disabled={(() => {
              if (actionss === "copy") return false;
              return edit;
            })()}
            onChange={(value) => {
              onChange(value);
            }}
            changeOnSelect={enableChangeOnSelect}
            // displayRender={displayRender}
            suffixIcon={<img src={NextIcon} alt="" />}
            placeholder={placeHolderText || "Please select"}
          />
        </Form.Item>
      )}
    </>
  );
};

export default SingleLocationInput;
